import styled, { css } from 'styled-components';
import media from '../../../styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';

let isMobile = isMobileDevice();

export const UserDetailsContainer = styled.div`
    margin: 13px;
    display: ${isMobile ? 'flex' : 'none'};
    flex-direction: column;
    color: #ffffff;

    ${media.portraitDevice`
        display: flex;
    `}

    ${media.mobileDevice`
        display: flex;
        margin-bottom: 6px;
    `}
`;

export const SalesContainer = styled.div`
    height: 50px;
    overflow-y: scroll;
    ${media.portraitDevice`
        ${({ isSideNavBar }) =>
            isSideNavBar &&
            css`
                text-align: left;
            `}
    `}
`;

export const MyProfileContainer = styled.div.attrs(({ onClick }) => ({
    onclick: onClick,
}))`
    margin: 5px 0 0 0;
    color: #12c8f7;
    font-family: AvenirNextWorld Demi;
    text-align: left;
    cursor: pointer;
`;

export const ExtraContainer = styled.span`
    font-family: AvenirNextWorld Demi;
    color: #12c8f7;
    margin: 0 5px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    line-height: 25px;
    cursor: pointer;
`;

export const LogOutPopUpDiv = styled.div`
    width: 350px;
    display: flex;
    flex-direction: column;
    height: ${({ divHeight }) => (divHeight ? divHeight : '63px')};
    ${media.mobileDevice`
         width:310px;
         height:160px;                 
    `}
`;

export const PopUpText = styled.div`
    color: #130e4a;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 18px;
    width: 185px;
    height: 100px;
    text-align: left;
    ${media.mobileDevice`    

    `};
`;

export const PopUpDesktopWrap = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : ''};

    ${media.mobileDevice` 
        flex-wrap:wrap;
    `};
`;
